

// ─── Enums ───────────────────────────────────────────────────────────────────

export enum BidType {
  Preferential = 'preferential',
  Daily        = 'daily',
  Monthly      = 'monthly',
}

// ─── Statistics API ──────────────────────────────────────────────────────────

export interface ParticipationStatistics {
  buyers: number;
  sellers: number;
  active_participants: number;
  bids_accepted: number;
  bids_rejected: number;
  total_energy_traded: number;
}

export interface DashboardSummary {
  total_bids: number;
  strike_price: number;
  total_value: number;
  energy_traded: number;
  untraded_energy: number;
  percentage_change: number;
}

export interface StatisticsResponse {
  participation_statistics: ParticipationStatistics;
  dashboard_summary: DashboardSummary;
}

// ─── Combined stat shape used internally when merging multiple bid types ─────

export interface CombinedStats {
  buyers: number;
  sellers: number;
  active_participants: number;
  bids_accepted: number;
  bids_rejected: number;
  total_energy_traded: number;
  total_bids: number;
  strike_price: number;
  total_value: number;
  energy_traded: number;
  untraded_energy: number;
  percentage_change: number;
}
